import { Button } from '@shared/components/ui/button';
import { Select, SelectContent, SelectTrigger, SelectValue } from '@shared/components/ui/select';
import React from 'react';

interface SelectWithClearProps {
  value: string;
  onValueChange: (value: string) => void;
  onClear: () => void;
  placeholder: string;
  children: React.ReactNode;
}

export const SelectWithClear: React.FC<SelectWithClearProps> = ({
  value,
  onValueChange,
  onClear,
  placeholder,
  children,
}) => (
  <div className="relative">
    <Select
      key={value || 'empty'}
      value={value || undefined}
      onValueChange={(newValue) => onValueChange(newValue || '')}
    >
      <SelectTrigger className={value ? 'pr-8' : ''}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>{children}</SelectContent>
    </Select>
    {value && (
      <Button
        variant="ghost"
        size="sm"
        className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6 p-0 hover:bg-transparent"
        onClick={(e) => {
          e.stopPropagation();
          onClear();
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-muted-foreground hover:text-foreground"
        >
          <path d="m18 6-12 12" />
          <path d="m6 6 12 12" />
        </svg>
      </Button>
    )}
  </div>
);
